// File: assets/custom-animations.js
// Lightweight scroll animations using IntersectionObserver + CSS (replaces GSAP + ScrollTrigger)

(function() {
  // Inject animation CSS once
  var style = document.createElement('style');
  style.textContent =
    '.gsap-fade-up,.gsap-stagger-child{opacity:0;transform:translateY(50px);transition:opacity 1s cubic-bezier(.25,.46,.45,.94),transform 1s cubic-bezier(.25,.46,.45,.94);}' +
    '.gsap-fade-up.is-visible,.gsap-stagger-child.is-visible{opacity:1;transform:translateY(0);}';
  document.head.appendChild(style);

  function initAnimations() {
    // --- Animation 1: Simple Fade-Up ---
    var fadeEls = document.querySelectorAll('.gsap-fade-up');
    if (fadeEls.length) {
      var fadeObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            fadeObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px -15% 0px' });
      fadeEls.forEach(function(el) { fadeObserver.observe(el); });
    }

    // --- Animation 2: Staggered Fade-Up ---
    var containers = document.querySelectorAll('.gsap-stagger-container');
    if (containers.length) {
      var staggerObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var children = entry.target.querySelectorAll('.gsap-stagger-child');
            children.forEach(function(child, i) {
              child.style.transitionDelay = (i * 0.2) + 's';
              child.classList.add('is-visible');
            });
            staggerObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px -20% 0px' });
      containers.forEach(function(c) { staggerObserver.observe(c); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnimations);
  } else {
    initAnimations();
  }
})();
